import styled from "styled-components"
import { FlexBox } from "@brg/ui"
import { LayoutConst } from "core"
import { RectangularButtonFilled } from "shared/components/buttons"

export const SuccessModalContainer = styled(FlexBox)`
  width: 100%;
  min-height: 100%;
  justify-content: center;
  align-items: center;
  padding: 40px 16px;
`

export const SuccessModalContent = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
`

export const SuccessModalTitle = styled.h2`
  margin: 0;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  letter-spacing: -2%;
  color: #151514;
  white-space: pre-line;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 22px;
    line-height: 28px;
  }
`

export const SuccessModalDescription = styled.p`
  margin: 0;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #151514;
  white-space: pre-line;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 15px;
    line-height: 20px;
  }
`

export const SuccessModalButton = styled(RectangularButtonFilled)`
  width: 100%;
  margin-top: 24px;
  padding: 0 32px;
  height: 48px;
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  background-color: #151514;
  color: #ffffff;

  &:hover,
  &:focus,
  &:active {
    background-color: #302f2f;
    color: #ffffff;
  }
`
import styled from "styled-components"
import { FlexBox } from "@brg/ui"
import { LayoutConst } from "core"
import { RectangularButtonFilled } from "shared/components/buttons"

export const SuccessModalContainer = styled(FlexBox)`
  width: 100%;
  min-height: 100%;
  justify-content: center;
  align-items: center;
  padding: 40px 16px;
`

export const SuccessModalContent = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
`

export const SuccessModalTitle = styled.h2`
  margin: 0;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  letter-spacing: -2%;
  color: #151514;
  white-space: pre-line;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 22px;
    line-height: 28px;
  }
`

export const SuccessModalDescription = styled.p`
  margin: 0;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #151514;
  white-space: pre-line;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 15px;
    line-height: 20px;
  }
`

export const SuccessModalButton = styled(RectangularButtonFilled)`
  width: 100%;
  margin-top: 24px;
  padding: 0 32px;
  height: 48px;
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  background-color: #151514;
  color: #ffffff;

  &:hover,
  &:focus,
  &:active {
    background-color: #302f2f;
    color: #ffffff;
  }
`
